import axios from 'axios';


export default {
    getPlansData:()=>{
        return axios.get('plan/detalles');
    },
    addPaymentMethod:(data)=>{
        return axios.post('plan/agregar/metodo/pago',data);
    },
    createCustomer:()=>{
        return axios.get('plan/crear/customer');
    },
    getCurrentPlanDetail:()=>{
        return axios.get('plan/estatus');
    },
    subscribePlan:(data)=>{
        return axios.post('plan/suscribirse',data);
    },
    cancelSubscription(){
        return axios.get('plan/cancelar/suscripcion');
    },
    listInvoices(){
        return axios.get('plan/facturas');
    },
    saveFactureData:(data)=>{
        return axios.post('plan/guardar/facturas',data);
    },
    deactivateSendFacture:()=>{
        return axios.get('plan/desactivar/facturas');
    },
    getCouponInfo:(data)=>{
        return axios.post('detalles/promocion',data);
    }
    
}